import ColumnGroup from "antd/es/table/ColumnGroup";
import { USER_KEY } from "../const";
import * as _ from "lodash";
import moment from 'moment-timezone';

export const useAuth = () => {
  const userData = localStorage.getItem(USER_KEY)
  return userData ? true : false;
}

export const numberFormat = (_number) => {
  return new Intl.NumberFormat('en-US').format(_number);
}

export const base64ToBlob = (dataurl) => {

  const arr = dataurl.split(",");

  const mime = arr[0].match(/:(.*?);/)[1];
  const sliceSize = 10;
  const byteChars = window.atob(arr[1]);
  const byteArrays = [];



  for (
    let offset = 0, len = byteChars.length;
    offset < len;
    offset += sliceSize
  ) {
    let slice = byteChars.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: mime });
};


export const resizeImage = (base64Str, maxWidth = 400, maxHeight = 350) => {
  return new Promise((resolve) => {
    let img = new Image();
    img.src = base64Str;
    img.onload = () => {
      let canvas = document.createElement("canvas");
      const MAX_WIDTH = maxWidth;
      const MAX_HEIGHT = maxHeight;
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL());
    };
  });
};

export const convertCurrency = (currency) => {
  switch (currency) {
    case 'ກີບ': case 'LAK':
      return "₭";
    case "ບາດ": case "BAHT":
      return "฿";
    case "ໂດລາ": case "USD":
      return `$`;
    default:
      return "₭";
  }
};

export const convertDeliveryMethod = (data) => {
  switch (data) {
    case 'DELIVERY_TO':
      return "ສົ່ງເຖິງທີ່";
    case "PICKUP":
      return "ຮັບເຄື່ອງເອງ";
    case "SHIPPING_COMPANY":
      return `ບໍລິສັດຂົນສົ່ງ`;
    case "OVERSEAS_DELIVERY":
      return `ສົ່ງຕ່າງປະເທດ`;
    default:
      return "ບໍລິສັດຂົນສົ່ງ";
  }
};

export const convertRole = (data) => {
  switch (data) {
    case 'ADMIN':
      return "ຜູ້ບໍລິຫານ";
    case "USER":
      return "ຜູ້ນຳໃຊ້ທົ່ວໄປ";
    case "STAFF":
      return `ພະນັກງານຂາຍ`;
    default:
      return "ຜູ້ບໍລິຫານ";
  }
};

export const calculateTotalPrice = (currency, order) => {
  switch (currency) {
    case "ບາດ":
    case "ໂດລາ":
    case "ກີບ":
      return order.currency === currency ? order.totalPrice : 0;
    default:
      return 0;
  }
};


export const covertTimeZone = (datatime, time) => {
  const thaiTimezone = moment(datatime).tz("Asia/Bangkok").format(`DD/MM/YYYY ${time ? time : ''}`);

  return thaiTimezone
}
export const NewCovertTimeZone = (date) => {
  return moment(date).tz("Asia/Bangkok").format(`YYYY-MM-DD`);
}

export const calculateTotalPaid = (sumPrice, currency, prepareRate = {}) => {

  let totalKip = 0, totalBaht = 0, totalUsd = 0;

  const bahtRate = prepareRate?.baht || prepareRate?.bahtRate || 1;
  const usdRate = prepareRate?.usd || prepareRate?.usdRate || 1;

  switch (currency) {
    case "LAK":
      totalKip = sumPrice;
      totalBaht = sumPrice / bahtRate;
      totalUsd = sumPrice / usdRate;
      break;
    case "BAHT":
      totalKip = sumPrice * bahtRate;
      totalBaht = sumPrice;
      totalUsd = sumPrice / (usdRate / bahtRate);
      break;
    case "USD":
      totalKip = sumPrice * usdRate;
      totalBaht = sumPrice * (usdRate / bahtRate);
      totalUsd = sumPrice;
      break;
    default:
      totalKip = 0;
      totalBaht = 0;
      totalUsd = 0;
      break;
  }

  return { totalKip, totalBaht, totalUsd };
};

export const splitDateTime = (dateString) => {
  const date = new Date(dateString);
  const datePart = date.toISOString().split('T')[0];
  const timePart = date.toISOString().split('T')[1].split('.')[0];
  return datePart;
};

export const convertImageToBase64 = async (imageUrl) => {
  try {
    
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  } catch (error) {
    console.log("Error converting image to Base64:", error);
    return null;
  }
};


export const convertOrderStatus = (status) => {
  let title = "-"
  switch (status) {
      case "CREATED":
          title = "ອໍເດີ້ເຂົ້າ"
          break;
      case "READY_TO_SHIPPING":
          title = "ອໍເດີພ້ອມສົ່ງ"
          break;
      case "SHIPPING":
          title = "ອໍເດີຢູ່ໃນລະຫວ່າງຈັດສົ່ງ"
          break;
      case "SHIPPINGCOMPLETED":
          title = "ຈັດສົ່ງສໍາເລັດ"
          break;
      case "COMPLETED":
          title = "ສໍາເລັດ"
          break;
      case "CANCELLED":
          title = "ສົ່ງຄືນ"
          break; 
      case "WAITINGCONFIRM":
          title = "ລໍຖ້າຢືນຢັນ"
          break; 
      case "NOTYETPAID":
          title = "ຍັງບໍ່ຈ່າຍເງິນ"
          break; 
      case "INDEBTED":
          title = "ຄ້າງໜີ້"
          break; 
      case "PAYMENT_PROCESSING":
          title = "ລໍຖ້າການຊຳລະ"
          break;
      default:
          title = status || "-"
          break;
  }
  return title
}
 
export const SHOP_CODE_LAST = (digit) => JSON.parse(localStorage.getItem("SHOP_DATA")).id.slice(-digit).toUpperCase();

// Utility function to format number with commas
export const FormatNumber = (num) => {
    if (!num) return '';
    
    // If num is a string with non-numeric characters (except commas), just return it
    if (typeof num === 'string' && isNaN(num.replace(/,/g, ''))) {
        return num;
    }
    
    // Remove existing commas and format
    const value = typeof num === 'string' ? num.replace(/,/g, '') : num.toString();
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Handle input change number
export const HandleChangeNumber = (e) => {
  const value = e.target.value;
  
  // Remove commas for storing the actual number
  return value.replace(/,/g, '');
};

export const HandleCurrency = (currency) => {
  switch (currency) {
      case "LAK":
      case "ກີບ":
          return "LAK";
      case "BAHT":
      case "ບາດ":
          return "BAHT";
      case "USD":
      case "ໂດລາ":
          return "USD";
      default:
          return "LAK"
  }
}